import * as React from "react";
import "./imagePeviewInOrderBox.css";
export function ImagePreviewInOrderBox(props) {
    return (React.createElement("div", { className: "image-preview-in-order-container" },
        React.createElement("img", { src: props.imageUrl, className: "image-preview-in-order ph-no-capture", onDragStart: (event) => event.preventDefault(), onContextMenu: (event) => event.preventDefault(), onLoad: (event) => {
                const width = event.currentTarget.width;
                const height = event.currentTarget.height;
                const isVertical = height / width > 1;
                props.onSizeKnown(isVertical ? "vertical" : "horizontal");
            }, height: props.resource ? 200 : undefined }),
        props.resource && (React.createElement("img", { src: props.resource.url, className: "resource-layer-in-preview", style: {
                left: props.resource.metadata.shiftX + "px",
                top: props.resource.metadata.shiftY + "px",
            } }))));
}
